import SideMenu from '../navigation/side-menu';
import { CART_POPUP } from '../classnames/cart-popup';

export default class VisibilityHandler {
  sideMenu = new SideMenu();
  menuContainerId = 'cart-popup-container';

  showMenu = () => {
    document.dispatchEvent(new CustomEvent('open-cart'), {
      bubbles: true
    });

    this.sideMenu.hideAll();
    this.sideMenu.show(this.menuContainerId);
  };

  closeMenu = () => this.sideMenu.hide(this.menuContainerId);

  initializeEventListeners = () => {
    if (new window.URLSearchParams(window.location.search).get('cart') === 'true') {
      this.showMenu();
    }

    [...document.getElementsByClassName(CART_POPUP)]
      .forEach((element) => element.addEventListener('click', this.showMenu));
  };
}
